function roundEuro(i){
	var tmp=Math.floor(i*1000);
	var mod=tmp%10;
	if(mod==0){
		i=Math.ceil(i*100)/100;
	}else if(mod<6){
		i=Math.floor(i*100)/100;
	}else {
		i=Math.ceil(i*100)/100;
	}
	return i;
}
function price(i){
	i=roundEuro(i)+'';
	i=i.replace('.',',');
	if(i.indexOf(',') == i.length-2 && i.indexOf(',')>-1)i+='0';
	i+=' zł';
	return i;
}

function changeDeliveryType() {

	if (checkValues()) {
		$('.order_navigate').removeClass('error error2');
		$('.delivery-type-list').removeClass('statusError');
		loadingStart();
		$('#F_ACTION').val('CHANGE_DELIVERY_TYPE');
	}
}

function deliveryTypeListInit(){
	var id,
		element,
		item_checked = $('.delivery-type-list .item.item-checked');

	function showActiveElement() {
		var active_element = $('.delivery-type-list .item.item-checked'),
			id = active_element.find('input[type="radio"]').val();

		$('.delivery-descriptions .descr-item').hide();
		$('.delivery-descriptions .item-'+id).addClass('item-checked').show();
		listItemReady();
	}
	function isRadioChecked(element) {
		return element.find('input[type="radio"]').attr('checked');
	}
	function showSmallActiveElemenet(element, action) {
		if(isRadioChecked(element) != 0) {
			if (action == 'add') {
				element.addClass('item-checked-not-hovered');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-hovered');
			}
		} else {
			if (action == 'add') {
				element.addClass('item-checked-not-default');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-default');
			}
		}
	}
	function listItemReady(){
		if ($('.delivery-type-list').length > 0) {
			var deliveryMenuHeight = $('.delivery-type-list .menu-delivery').outerHeight();
			var deliveryTabHeight = $('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').outerHeight();
			if (deliveryTabHeight < deliveryMenuHeight) {
				$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').height(deliveryMenuHeight-14).addClass('item-ready');
			}
			$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').addClass('item-ready');
		}
	}
	listItemReady();
	$('.delivery-type-list .item').not('.item-checked').hover(function() {
		var $this = $(this);

		$this.addClass('item-hovered');
		id = $this.find('input[type="radio"]').val();
		element = $('.delivery-descriptions .item-'+id).addClass('item-hovered');

		$('.delivery-descriptions .descr-item').hide();
		element.show();

		listItemReady();

		showSmallActiveElemenet(item_checked, 'add');
	}, function() {
		$(this).removeClass('item-hovered');
		if(element){
			element.removeClass('item-hovered');
		}

		item_checked.removeClass('item-checked-not-hovered');

		showActiveElement();

		showSmallActiveElemenet(item_checked, 'remove');
	});
	$('.delivery-type-list .item').click(function(){
		var input=$(this).find('input[name="deliveryType"]');
		if(!input.is(':disabled')){
			input.prop('checked',true)[0].click();
		}
	});
}



function calculateCart() {
	if (checkValues()) {
		$('.order_navigate').removeClass('error error2');
		$('.payment-type-list').removeClass('statusError');
		loadingStart();
		$('#F_ACTION').val('SAVE');
	}
}


function frontLoginValidate(){		//pgrzech - validacja formularza logowania Rejestracji
	$('#j_username, #j_password, #captcha').keyup(function (event) {
		if(event.keyCode == 13){
			zaloguj();
		}
	});
	fancyRegulamin();
	$("#loginForm").validate({
		rules:{
			j_username: {
				required:true,
				trim:true
			},
			j_password: {
				required:true,
				minlength: 5
			},
			captcha:{
				required:true
			}

		},
		messages:{
			j_username: {
				required:'Podaj login(e-mail)',
				trim:'Pole nie może zawierać spacji'
			},
			j_password: {
				required:'Podaj hasło',
				minlength: 'Hasło jest za krótkie'
			},
			captcha:{
				required:'Podaj tekst z obrazka'
			}
		}
	});
	$('#regAck').click(function(){
		setTimeout(function(){
			$("#registerForm").validate().element('#regAck');
		},100);
	});
	passwordInvalid.init($('#password'), $('#password').parents().find('.password-invalid'), $('#password').closest('.row'), $('#email'));
	$("#registerForm").validate({
		rules:{
			firstname: {
				required: true,
				minlength: 2,
				firstname: true
			},
			surname: {
				required: true,
				minlength: 2,
				surname: true
			},
			password: {
				strongPassword: true
			},
			password2:{
				required: true,
				equalTo: "#password"
			},
			email:{
				required: true,
				email: true
			},
			statuteAccepted: "required"
		},
		messages:{
			firstname: {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			surname: {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			password:{
				required: 'Podaj hasło',
				minlength: 'Hasło musi mieć co najmniej {0} znaków',
				trim: 'Hasło jest niepoprawne'
			},
			password2:{
				required: 'Powtórz hasło',
				equalTo: 'Hasła muszą być identyczne'
			},
			//email weryfikowany JSON'em patrz jquery.validate.js validateEmail(mail)
			email:{
				required: 'Podaj adres e-mail',
				email: 'Podaj poprawny adres e-mail'
			},
			statuteAccepted: 'Akceptacja Regulaminu jest wymagana'
		}
	});
}

function promotedLayer(href){
	clearTimeout(hideTimer);
	container.css('display', 'none');
	$.fancybox({href:href},{
		width: 780,
		padding:0,
		height: 400,
		titleShow:false,
		type:'iframe'
	});
}

function zamawiam(){

	if(window.sessionStorage.getItem('operator-logged')==="true") {
		if(!updateWarrantyQuestionnaire()){
			return false;
		}
	}

	if(showInstalmentOrdersRequiringActionsForNextAction && $('#instalmentOrdersRequiringActions').length){
		instalmentOrdersRequiring();
		return false;
	}

	if(!$('input[name="deliveryType"]:checked').length){
		$('.order_navigate').addClass('error');
		$('.delivery-type-list').addClass('statusError');
		return false;
	}
	checkWarrantyUA();
	if (servicesInExcludedDeliveryEncouragement) {
		return false;
	}

}

function gotoZipCode(invalidZipCodeSelector){
	$(invalidZipCodeSelector).focus();
	$.scrollTo(invalidZipCodeSelector,800);
}

function checkMasterpassTermAccepted(input){
	if( $(input).prop("checked") ){
		$('.order_navigate').removeClass('error3');// + error?
	}
	else{
		$('.order_navigate').addClass('error3');
	}
}

function openAddSourceParam(form) {

	$.fancybox({href: '/add-source-param.ltr?operator_form=' + form},
			{
				autoDimensions : true
			}
	);
}
